module.exports = __webpack_public_path__ + "img/bg1.2f1e38ea.png";